// extracted by mini-css-extract-plugin
export default {"card":"project-view_card__OaQSp"};